var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextDouble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 42,
    viewBox: "0 0 53 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.649 4.60837C12.649 2.02873 11.3624 0 7.60681 0C3.11227 0 0 3.32292 0 8.20237C0 14.2886 11.2233 19.2467 17.1783 20.9956C11.2233 22.7533 0 27.7114 0 33.7976C0 38.6858 3.11227 42 7.60681 42C11.3624 42 12.649 39.9713 12.649 37.3916C12.649 34.812 11.8231 33.3342 10.0845 33.3342C8.25012 33.3342 7.42424 34.5322 4.85966 34.5322C2.75584 34.5322 2.32116 32.2498 3.39046 30.6321C6.92871 25.2979 27.115 21.4853 35.0087 20.9956C27.1237 20.5059 6.92871 16.6933 3.39046 11.3592C2.32116 9.75016 2.75584 7.45909 4.85966 7.45909C7.42424 7.45909 8.25012 8.65709 10.0845 8.65709C11.9188 8.65709 12.649 7.09182 12.649 4.59963",
    fill: "#D6AF66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.649 4.60837C30.649 2.02873 29.3624 0 25.6068 0C21.1123 0 18 3.32292 18 8.20237C18 14.2886 29.2233 19.2467 35.1783 20.9956C29.2233 22.7533 18 27.7114 18 33.7976C18 38.6858 21.1123 42 25.6068 42C29.3624 42 30.649 39.9713 30.649 37.3916C30.649 34.812 29.8231 33.3342 28.0845 33.3342C26.2501 33.3342 25.4242 34.5322 22.8597 34.5322C20.7558 34.5322 20.3212 32.2498 21.3905 30.6321C24.9287 25.2979 45.115 21.4853 53.0087 20.9956C45.1237 20.5059 24.9287 16.6933 21.3905 11.3592C20.3212 9.75016 20.7558 7.45909 22.8597 7.45909C25.4242 7.45909 26.2501 8.65709 28.0845 8.65709C29.9188 8.65709 30.649 7.09182 30.649 4.59963",
    fill: "#D6AF66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextDouble);
export default __webpack_public_path__ + "static/media/next-double.898949588d8e5cdf5a80072b41a2588d.svg";
export { ForwardRef as ReactComponent };